var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAuctionBet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.605,
    height: 31.971,
    viewBox: "328 599.029 31.605 31.971",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "auction-line"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346 628v3h-18v-3h18Zm.879-28.971 11.667 11.667-2.121 2.124-1.59-.531-3.716 3.711 8.486 8.485-2.121 2.121-8.484-8.485-3.606 3.606.425 1.698-2.123 2.121-11.667-11.667 2.122-2.121 1.696.423 9.44-9.44-.529-1.59 2.121-2.122Zm1.06 5.304-10.606 10.605 5.302 5.304 10.607-10.605-5.303-5.304Z",
    fill: "#541690",
    fillRule: "evenodd",
    "data-name": "Path 175"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuctionBet);
export default __webpack_public_path__ + "static/media/auction-bet.7c515959.svg";
export { ForwardRef as ReactComponent };